export interface ArticleCard {
  id: string;
  title: string;
  excerpt: string;
  author: string;
  date: string;
  accent: string;
  slug: string;
}

export const homepageArticles: ArticleCard[] = [
  {
    id: 'article-1',
    title: 'What Is a Hipobuy Spreadsheet and Why Every Smart Shopper Needs One',
    excerpt: 'A Hipobuy spreadsheet is more than just a product list — it is a curated, regularly updated resource that organizes the best product finds across multiple categories. From sneakers and streetwear to accessories and fragrances, these spreadsheets save hours of manual searching and help shoppers discover hidden gems they would otherwise miss entirely.',
    author: 'Marco Chen',
    date: 'July 5, 2026',
    accent: 'bg-accent-100',
    slug: '/hipobuy-spreadsheet-guide',
  },
  {
    id: 'article-2',
    title: 'How to Use Product Spreadsheets for Smarter Shopping in 2026',
    excerpt: 'Navigating the world of online product research can feel overwhelming — hundreds of stores, thousands of listings, and endless scrolling. Product spreadsheets cut through the noise by organizing everything into clean, filterable formats. Learn how to leverage these tools to compare prices, spot trends, and make confident purchasing decisions.',
    author: 'Sarah Mitchell',
    date: 'June 28, 2026',
    accent: 'bg-primary-100',
    slug: '/hipobuy-spreadsheet-guide',
  },
  {
    id: 'article-3',
    title: 'Hipobuy Spreadsheet vs Traditional Shopping: A Complete Comparison',
    excerpt: 'Traditional online shopping means visiting each store individually, comparing prices manually, and hoping you do not miss a better deal elsewhere. A Hipobuy spreadsheet consolidates everything into a single organized view — complete with direct links, size guides, and community ratings — making the comparison process lightning fast and dramatically more effective.',
    author: 'James Okafor',
    date: 'June 20, 2026',
    accent: 'bg-secondary-200',
    slug: '/hipobuy-spreadsheet-guide',
  },
  {
    id: 'article-4',
    title: 'Top 10 Product Categories to Explore on a Hipobuy Spreadsheet',
    excerpt: 'From the latest sneaker releases to hard-to-find designer belts, a well-maintained Hipobuy spreadsheet covers an impressive range of categories. Discover which sections deliver the most value — including shoes, hoodies, jackets, bags, and accessories — and learn tips for navigating each category efficiently to find exactly what you are looking for.',
    author: 'Elena Rossi',
    date: 'June 15, 2026',
    accent: 'bg-accent-100',
    slug: '/hipobuy-spreadsheet-guide',
  },
  {
    id: 'article-5',
    title: 'Beginner Guide to Understanding Spreadsheet Shopping Platforms',
    excerpt: 'If you are new to the concept of spreadsheet-based shopping, this guide walks you through everything from the basics. Understand what platforms like Hipobuy, Kakobuy, CSSBuy, Superbuy, and Oopbuy offer, how their spreadsheets differ, and which one might be the best fit for your shopping style and budget preferences.',
    author: 'David Park',
    date: 'June 8, 2026',
    accent: 'bg-primary-100',
    slug: '/hipobuy-spreadsheet-guide',
  },
  {
    id: 'article-6',
    title: 'Safety Tips for Buying Products Through Spreadsheet Links',
    excerpt: 'While spreadsheet shopping opens up incredible opportunities, staying safe should always be the top priority. Learn essential safety practices — such as verifying seller ratings, checking link authenticity, understanding return policies, and knowing your payment protection options — to shop with confidence and peace of mind.',
    author: 'Aisha Mohammed',
    date: 'May 30, 2026',
    accent: 'bg-secondary-200',
    slug: '/hipobuy-spreadsheet-guide',
  },
];